<template>
  <v-alert dense type="error" color="#4cc6b5" v-if="issystemNotification">
    <span v-for="(msg, index) in infoText" :key="index">{{ msg }}<br /></span>
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElSystemNotification',
  computed: {
    ...mapGetters(['systemNotification']),
    issystemNotification() {
      return this.systemNotification?.show
    },
    infoText() {
      return this.$i18n.locale === 'lt'
        ? this.systemNotification.system_notification_lt
        : this.systemNotification.system_notification_en
    },
  },
}
</script>

<style lang="scss"></style>
